import {inject, observer} from 'mobx-react';
import React, {useState, useEffect} from 'react';
import AiAssistnatChatbotUI from '../view/AiAssistantChatbotUI';
import AiAssistantChatbotStore from '../store/AiAssistantChatbotStore';
import NavigationStore from '../../../navigation/store/NavigationStore';
import ConfirmationModal from '../../../uiToolkit/ConfirmationModal';
import {aiAssitantChatbotText} from '../aiAssistantChatbotText';
import {usePageChatbot} from '../hooks/usePageChatbot';
import {useWidgetChatbot} from '../hooks/useWidgetChatbot';

type AiAssistantChatbotUIType = 'page' | 'widget';

interface Props {
  aiAssistantChatbotStore?: AiAssistantChatbotStore;
  navigationStore?: NavigationStore;
  onClosed?: () => void;
  onOpened?: () => void;
  learnerView?: boolean;
  uiType?: AiAssistantChatbotUIType;
}

const AiAssistantChatbotContainer = inject(
  'aiAssistantChatbotStore',
  'navigationStore',
)(
  observer(
    ({
      aiAssistantChatbotStore,
      navigationStore,
      onClosed,
      onOpened,
      uiType = 'widget',
    }: Props) => {
      const [showDeleteConfirmation, setShowDeleteConfirmation] =
        useState(false);

      const {chat, title, assistantAvatar, sendMessage, clearChat} =
        uiType === 'page'
          ? usePageChatbot(aiAssistantChatbotStore)
          : useWidgetChatbot(aiAssistantChatbotStore, navigationStore);

      useEffect(() => {
        if (aiAssistantChatbotStore?.shouldShowChatbot && onOpened) onOpened();
        if (!aiAssistantChatbotStore?.shouldShowChatbot && onClosed) onClosed();
      }, [aiAssistantChatbotStore?.shouldShowChatbot]);

      const onShowDeleteHistory = () => setShowDeleteConfirmation(true);

      return aiAssistantChatbotStore?.shouldShowChatbot ? (
        <>
          <AiAssistnatChatbotUI
            chat={chat}
            onClearAssistantChat={onShowDeleteHistory}
            onSendMessage={sendMessage}
            isLoading={aiAssistantChatbotStore.isLoading}
            isSendingMessage={aiAssistantChatbotStore.isSendingMessage}
            assistantTitle={title}
            assistantAvatar={assistantAvatar}
            uiType={uiType}
          />
          <ConfirmationModal
            title={aiAssitantChatbotText.chatHistoryDeleteConfirmation}
            acceptText={aiAssitantChatbotText.yes}
            shown={showDeleteConfirmation}
            onAccept={async () => {
              await clearChat();
              setShowDeleteConfirmation(false);
            }}
            onCancel={() => setShowDeleteConfirmation(false)}
          />
        </>
      ) : null;
    },
  ),
);

export default AiAssistantChatbotContainer;
